import { useMemo } from 'react';
import { useI18n } from './I18nProvider';
import { money, compactMoney, dateLabel, timeLabel } from '../lib/format';
export function useFormat() {
  const { region } = useI18n();
  return useMemo(() => ({
    money: (value: number, currency = region.currency) => money(value, currency, region.locale),
    compactMoney: (value: number, currency = region.currency) => compactMoney(value, currency, region.locale),
    dateLabel: (date: string, options?: Intl.DateTimeFormatOptions) => dateLabel(date, options, region.locale),
    timeLabel: (ms: number, timezone = region.timezone) => timeLabel(ms, timezone, region.locale),
    number: (value: number, options?: Intl.NumberFormatOptions) => new Intl.NumberFormat(region.locale, options).format(value),
  }), [region.locale, region.currency, region.timezone]);
}
